import { serializeHtml } from 'components/text_editor_new/lib/serialize_html';

// Serializes for external sources, such as emails. Ensures we don't leave stray, non-standard HTML tags in,
// such as variables or placeholders.
export default function serializeHtmlExternal(editor) {
  return serializeHtml(editor, { forExternalUse: true });
}
